import {allFirstLevelObjectKeysAreNonNullable} from '../../../utils/common-utils';
import {
  OptionsType,
  SimilarHotelsAPIResponseTypes,
} from '../components/SimilarHotels/SimilarHotels';
import {detailsAPIEndPoints} from '../../../config/api-config';

export const defaultSimilarHotelsAPIData: SimilarHotelsAPIResponseTypes = {
  data: [],
  city_meta_info: {
    ac: [],
  },
};

import {getSimilarHotelData} from '@ibibo/get-hotel-detail-page-data';

const fetchSimilarHotels = async (options: OptionsType) => {
  const {checkinYYYYMMDD, checkoutYYYYMMDD, pax, cityId, hotelCode} = options;

  if (!allFirstLevelObjectKeysAreNonNullable(options)) {
    return [];
  }

  /** copied from old fore code */
  const filter = {
    gosuggest: [
      {
        vhid: hotelCode,
        type: 0,
      },
    ],
  };

  /** copied from old fore code */
  const queryString = `?&cur=INR&f=${JSON.stringify(filter)}&pid=0&s=popularity`;

  // const strQry = `hotels-${cityId}-${checkinYYYYMMDD}-${checkoutYYYYMMDD}-${pax}`;

  const url = detailsAPIEndPoints.similarHotels({
    cityId,
    checkin: checkinYYYYMMDD,
    checkout: checkoutYYYYMMDD,
    hyphenatedPax: pax,
    queryString,
  });

  // console.log(url)

  let similarHotelsData: SimilarHotelsAPIResponseTypes | null = null;
  let error: null | Error = null;

  try {
    const response = await getSimilarHotelData({url});

    if (response) {
      similarHotelsData = (response && response) || defaultSimilarHotelsAPIData;
    }
  } catch (e) {}

  return [similarHotelsData, error] as [SimilarHotelsAPIResponseTypes, Error];
};

export default fetchSimilarHotels;
